/**
 * Downloads a ZIP file from a given URL.
 * @param url - The full URL to the ZIP file.
 * @param filename - Optional custom filename (defaults to filename from URL).
 */

export const downloadZip = (url: string, filename?: string) => {
  if (!url) {
    console.warn('No URL provided for download.')
    return
  }

  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = filename || ''
  document.body.appendChild(anchor)
  anchor.click()
  document.body.removeChild(anchor)
}
